<template>
  <div class="intro-panel">
    <h2 class="-large-title">Please wait</h2>
    <div class="info">
      <p>The event is being prepared.</p>
      <p>Take some time to read the event introduction.</p>
    </div>
    <img src="@/assets/background-wait.svg" class="image" alt="Please wait" @click="$emit('done')" />
  </div>
</template> 

<script>
export default {
  mounted () {
    setTimeout(() => {
      this.$store.dispatch('traineeStatusModule/setViewedIntro', true);
      this.$emit('done')
    }, 5000);
  }
}
</script>

<style lang="scss" scoped>
  .intro-panel {
    height: 100%;
    background: white;
    padding: 20px;
    display: flex;
    color: #3d3dde;

    display: grid;
    grid-template-areas: 
      "title image"
      "info image";
    grid-template-columns: 2fr 1.5fr;
    grid-template-rows: min-content 500px;

    div {
      margin-right: 140px;
    }
  }

  .image {
    grid-area: image;
    max-width: 100%;
  }
  
  h2 {
    grid-area: title;
  }
  .info {
    grid-area: info;
  }
  .btn {
    display: inline-flex;
  }
  p {
    font-size: 20px;
    color: #3D3DDE;
    max-width: 400px;
  }

  @media all and (max-width: 767px) {
    .intro-panel {      
      grid-template-areas: 
        "title"
        "info"
        "image";
      grid-template-columns: 1fr;
      grid-template-rows: min-content min-content 500px;

      div {
        width: 100%;
        margin-right: 0;
      }
    }
    h2 {
      font-size: 36px;
    }
    p {
      font-size: 18px;
    }
    i {
      margin: 0 auto;
    }
  }
</style>